<template>
  <!--原材料费率框-->
  <a-input-number
    :min="0"
    :formatter="value => `${value}%`"
    v-model="rate"
    @change="onChange"
    style="width: 100%"
  ></a-input-number>
</template>

<script>
export default {
  data () {
    return {
      rate: null
    }
  },
  mounted () {
    this.getInit()
  },
  methods: {
    getInit () {
      if (this.record.rate) {
        this.rate = this.record.rate
      }
    },
    onChange () {
      this._value = this.rate
    }
  },
  syncProps: ['value', '_value'],
  props: {
    record: Object,
    value: null
  }
}
</script>

<style scoped>

</style>
